const Cookies = require("js-cookie");
const API = require("./api");

const SESSION_DURATION_MINS = 30;
const TOKEN_KEY = process.env.TOKEN_KEY || "token";
const TOKEN_DOMAIN = process.env.TOKEN_DOMAIN || "localhost";
const DISABLE_CAPTCHA = process.env.DISABLE_CAPTCHA || false;

const setCaptchaObj = (captchaObj) => {
  this.captchaObj = captchaObj;
};

const getCaptchaObj = () => {
  return this.captchaObj;
};

const resetCaptchaObj = () => {
  return this.captchaObj.reset();
};

const validateCaptchaObj = () => {
  const captcha = getCaptchaObj().getValidate();
  if (!captcha)
    document.querySelector(".geetest_radar_tip").style.color = "red";

  return captcha;
};

const captchaHandler = (captchaObj) => {
  captchaObj.appendTo("#captcha");
  captchaObj.onReady(function () {
    document.getElementById("wait").style.display = "none";
  });
  setCaptchaObj(captchaObj);
};

const onCaptchaLoad = () => {
  API.getCaptchaParams().then((data) => {
    window.onCaptchaLoaded();
    window.initGeetest(
      {
        gt: data.gt,
        challenge: data.challenge,
        offline: !data.success,
        new_captcha: data.new_captcha,
        lang: "en",
        product: "popup",
        width: "100%",
        https: true,
      },
      captchaHandler
    );
  }).catch((err) => {
    console.error("Failed to load captcha parameters:", err);
    document.getElementById("wait").innerHTML = "Error loading security verification. Please refresh.";
  });
};

const getValueById = (id) => document.getElementById(id).value;

const showPreloadForm = (e) => {
  e.classList.toggle("preload");
};

const onLoginSubmit = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");

  const email = getValueById("login:email").toLowerCase();

  const password = getValueById("login:password");

  const captcha = !DISABLE_CAPTCHA ? validateCaptchaObj() : {};

  if (!email || !password || !captcha) return;

  showPreloadForm($submitButton);

  API.login({ email, password }, captcha).then((res) => {
    showPreloadForm($submitButton);

    if (res.errors) {
      if (!DISABLE_CAPTCHA) {
        resetCaptchaObj();
      }
      document.getElementById("login:error").innerHTML = res.errors;
    } else {
      const { data } = res;
      Cookies.set(TOKEN_KEY, data.token, { domain: TOKEN_DOMAIN });

      const expDate = new Date();
      expDate.setMinutes(expDate.getMinutes() + SESSION_DURATION_MINS);

      localStorage.setItem("token_expires_at", expDate);

      window.location.href = process.env.TERMINAL_URL;
    }
  }).catch((err) => {
    showPreloadForm($submitButton);
    if (!DISABLE_CAPTCHA) {
      resetCaptchaObj();
    }
    document.getElementById("login:error").innerHTML = "Server is temporarily unavailable. Please try again later.";
    console.error("Login request failed:", err);
  });
};

const onSignupSubmit = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");

  const first_name = getValueById("signup:first_name");
  const last_name = getValueById("signup:last_name");
  const email = getValueById("signup:email").toLowerCase();
  const password = getValueById("signup:password");
  const password_confirmation = getValueById("signup:password_confirm");
  const captcha = !DISABLE_CAPTCHA ? validateCaptchaObj() : {};
  const click_id = sessionStorage.getItem("click_id");

  if (
    !email ||
    !password ||
    !first_name ||
    !last_name ||
    !password_confirmation ||
    !captcha
  )
    return;

  showPreloadForm($submitButton);

  API.signup(
    {
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
      click_id
    },
    captcha
  ).then((res) => {
    showPreloadForm($submitButton);

    if (res.errors) {
      if (!DISABLE_CAPTCHA) getCaptchaObj().reset();

      if (typeof res.errors !== "string") {
        if (res.errors.password_confirmation) {
          document.getElementById("signup:error").innerHTML =
            "Passwords do not match";
        }

        if (res.errors.password) {
          document.getElementById(
            "signup:error"
          ).innerHTML = `Password ${res.errors.password[0]}`;
        }

        if (res.errors.email) {
          document.getElementById("signup:error").innerHTML =
            "Email has already been taken";
        }
      } else {
        document.getElementById("signup:error").innerHTML = res.errors;
      }
    } else {
      alert("Success! Please check your email to confirm your account");
      window.location.href = "/";
    }
  }).catch((err) => {
    showPreloadForm($submitButton);
    if (!DISABLE_CAPTCHA) getCaptchaObj().reset();
    document.getElementById("signup:error").innerHTML = "Server is temporarily unavailable. Please try again later.";
    console.error("Sign up request failed:", err);
  });
};

const onForgotPasswordSubmit = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");
  showPreloadForm($submitButton);

  const email = getValueById("forgot_password:email").toLowerCase();

  if (!email) return;

  API.resetPassword(email)
    .then(() => {
      showPreloadForm($submitButton);
      alert("Please check your email for the next steps");
    })
    .catch((error) => {
      if (error.message.includes("Too many requests")) {
        alert("Password cannot be changed frequently than once in 2 minutes");
      }
    })
    .finally(() => {
      window.location.href = "/";
    });
};

const setNewPassword = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");
  showPreloadForm($submitButton);

  // Extract confirmation token from URL;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");

  if (!token) document.location.href = "/";

  const password = getValueById("set_password:password");
  const password_confirmation = getValueById(
    "set_password:password_confirmation"
  );

  if (!password || !password_confirmation) return;

  if (password !== password_confirmation) {
    document.getElementById("set_password:error").innerHTML =
      "Passwords do not match";
    return;
  }

  API.setNewPassword(token, { password, password_confirmation }).then(
    ({ errors }) => {
      showPreloadForm($submitButton);

      if (errors) {
        document.getElementById(
          "set_password:error"
        ).innerHTML = errors.password
          ? `password ${errors.password[0]}`
          : "Token has expired, please request a new one";
      } else {
        alert("Password has been successfully set!");
        window.location.href = "/login.html";
      }
    }
  ).catch((err) => {
    showPreloadForm($submitButton);
    document.getElementById("set_password:error").innerHTML = "Server is temporarily unavailable. Please try again later.";
    console.error("Set new password request failed:", err);
  });
};

const confirmEmail = (e) => {
  e.preventDefault();
  showPreloadForm(e.target);

  // Extract confirmation token from URL;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");

  if (!token) document.location.href = "/";

  API.confirmEmail(token).then(({ errors }) => {
    showPreloadForm(e.target);

    if (errors) {
      alert("Unable to confirm: the confirmation link may be expired");
    } else {
      alert("Email has been successfully confirmed!");
      window.location.href = "/login.html";
    }
  }).catch((err) => {
    showPreloadForm(e.target);
    alert("Server is temporarily unavailable. Please try again later.");
    console.error("Email confirmation request failed:", err);
  });
};

const togglePasswordInput = (passwordInput) => {
  const eye = document.getElementsByClassName("closed-eye");

  if (passwordInput.type === "password") {
    passwordInput.type = "text";
    eye[0].style.display = "none";
  } else {
    passwordInput.type = "password";
    eye[0].style.display = "block";
  }
};

const toggleLoginPassword = () => {
  const passwordInput = document.getElementById("login:password");
  togglePasswordInput(passwordInput);
};

const toggleSignupPassword = () => {
  const passwordInput = document.getElementById("signup:password");
  const passwordConfirmInput = document.getElementById(
    "signup:password_confirm"
  );

  togglePasswordInput(passwordInput);
  togglePasswordInput(passwordConfirmInput);
};

if (document.getElementById("login:form")) {
  if (!DISABLE_CAPTCHA) {
    document.getElementById("login:form").onload = onCaptchaLoad();
  } else {
    document.getElementById("captcha").hidden = true;
  }
  document.getElementById("login:form").onsubmit = onLoginSubmit;
  document.getElementById("toggle").onclick = toggleLoginPassword;
}
if (document.getElementById("signup:form")) {
  if (!DISABLE_CAPTCHA) {
    document.getElementById("signup:form").onload = onCaptchaLoad();
  } else {
    document.getElementById("captcha").hidden = true;
  }
  document.getElementById("signup:form").onsubmit = onSignupSubmit;
  document.getElementById("toggle").onclick = toggleSignupPassword;
}
if (document.getElementById("forgot_password:form"))
  document.getElementById(
    "forgot_password:form"
  ).onsubmit = onForgotPasswordSubmit;
if (document.getElementById("set_password:form"))
  document.getElementById("set_password:form").onsubmit = setNewPassword;
if (document.getElementById("confirm_email:form"))
  document.getElementById("confirm_email:button").onclick = confirmEmail;
